const warning = require('warning');
const timers = require('timers');
const React = require('react');
const PropTypes = React.PropTypes;
const Popover = require('react-popover');
const classNames = require('classnames');
const SpringsMixin = require('../mixins/springs');

const PopoverBase = React.createClass({

  propTypes: {
    children: PropTypes.node.isRequired,
    placement: React.PropTypes.oneOf(['above', 'right', 'below', 'left', 'row', 'column', 'start', 'end', null]),
    arrow: PropTypes.bool,
    place: PropTypes.string,
    target: PropTypes.element.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onClosed: PropTypes.func,
    isGray: PropTypes.bool,

    // using these props is deprecated.
    // see: https://github.com/clara-labs/vogue/issues/89
    // instead, use <PopoverBase.CallToAction />
    callToActionText: PropTypes.string,
    onCallToActionClick: PropTypes.func,
  },

  mixins: [
    SpringsMixin([
      {
        key: 'popover',
        tension: 200,
        friction: 15,
        initialValue: 0,
      },
    ]),
  ],

  getDefaultProps() {
    return {
      isGray: false,
      placement: 'below',
    };
  },

  componentWillUpdate(_, nextState) {
    if (!this.state.isShaking && nextState.isShaking) {
      const shakeEndHandler = () => {
        this.setState({
          isShaking: false,
        });

        this.refs.content.containerEl.removeEventListener('animationend', shakeEndHandler);
      };

      this.refs.content.containerEl.addEventListener('animationend', shakeEndHandler);
    }
  },

  shake() {
    this.setState({
      isShaking: true,
    });
  },

  render() {
    warning(
      !this.props.callToActionText && !this.props.onCallToActionClick,
      'Use of callToActionText and onCallToActionClick props is deprecated. Consider using <PopoverBase.CallToAction /> as a child instead.'
    );

    const body = this.props.callToActionText ? (
      <div>
        { this.props.children }
        <PopoverBase.CallToAction onClick={ this.props.onCallToActionClick }>
          { this.props.callToActionText }
        </PopoverBase.CallToAction>
      </div>
    ) : this.props.children;

    const popoverClasses = classNames({
      'is-shaking': this.state.isShaking,
      'is-visibleArrow': this.props.arrow,
      'is-gray': this.props.isGray,
    });

    const noOp = () => {};

    const animationHandlers = {
      enter: (popover) => {
        this.setState({
          standing: popover.zone.standing,
        });

        this.springRefs.popover.setEndValue(1);
      },

      exit: (popover, callback) => {
        this.setState({
          standing: popover.zone.standing,
        });

        this.springRefs.popover.setEndValue(0);

        const closeListener = {

          onSpringUpdate: () => {

            // short circuit instead of waiting for spring to rest
            if (this.springRefs.popover.getCurrentValue() < 0.1) {
              callback();

              timers.setImmediate(() => {
                this.springRefs.popover.removeListener(closeListener);
              });

              if (this.props.onClosed) {
                this.props.onClosed();
              }
            }
          },
        };

        this.springRefs.popover.addListener(closeListener);
      },

      enterStop: noOp,
      exitStop: noOp,
    };

    const origin = {
      below: 'center top',
      above: 'center bottom',
      left: 'right center',
      right: 'left center',
    }[this.state.standing];

    const style = {
      transform: `scale(${ this.state.popoverSpringValue })`,
      WebkitTransform: `scale(${ this.state.popoverSpringValue })`,
      transformOrigin: origin,
      WebkitTransformOrigin: origin,
    };

    return (
      <Popover
        isOpen={ this.props.isOpen }
        preferPlace={ this.props.placement }
        onOuterAction={ this.props.onToggle }
        tipSize={ 12 }
        body={ body }
        animationHandlers={ animationHandlers }
        style={ style }
        ref="content"
        className={ popoverClasses }
      >
        { this.props.target }
      </Popover>
    );
  },
});

const PopoverCallToAction = (props) => {
  return (
    <div className="PopoverCallToAction" onClick={ props.onClick }>
      { props.children }
    </div>
  );
};
PopoverCallToAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

PopoverBase.CallToAction = PopoverCallToAction;

const PopoverPaddedContent = (props) => {
  return <div className="PopoverPaddedContent">{ props.children }</div>;
};
PopoverPaddedContent.propTypes = {
  children: PropTypes.node.isRequired,
};

PopoverBase.PaddedContent = PopoverPaddedContent;

PopoverBase.ActionBar = require('./popover-action-bar.react');

module.exports = PopoverBase;
